import * as _ from "lodash";

import { LineData } from "@ctra/api";

import { ChartContextType } from "../../../../providers";
import { SingleEntityLineChartProcessor } from "./Individual";
import { MultiEntityLineChartProcessor } from "./Combined";

export class Processor {
  static create(entities: ChartContextType<LineData>["values"]["entities"]) {
    if (_.size(entities) > 1) {
      return new MultiEntityLineChartProcessor();
    } else {
      return new SingleEntityLineChartProcessor();
    }
  }
}
